import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckmarkCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 17c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4s1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47z"
    />
    <path
      fill="currentColor"
      d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8"
    />
  </svg>
);
export default SvgCheckmarkCircle;
